module.exports = __webpack_public_path__ + "img/hj1.86b57e9f.jpg";